const section = document.querySelector(".lf-section-questionnaire");
const questions = section.querySelectorAll(".lf-reponse-wrapper");
const results = section.querySelectorAll(".lf-quiz-result-page");
const pagesScores = {};

let currentStep = 0;
const totalSteps = questions.length;


function showStep(index, back = false) {
	questions.forEach((question, i) => {
    if (index === i) {
      question.closest(".lf-question-response-container").classList.remove('hidden');
    } else {
      question.closest(".lf-question-response-container").classList.add("hidden");
    }
	});
  if (back) {
    currentStep -= 1;
  }
}


function updateScores() {
	const reponsesChecked = section.querySelectorAll(".lf-reponse-container input:checked");

	// Réinitialiser les scores
	Object.keys(pagesScores).forEach((key) => (pagesScores[key] = 0));

	reponsesChecked.forEach((input) => {
    const page = input.dataset.page;
    const pageTwo = input.dataset.pageTwo;

    if (page) {
      const points = parseInt(input.dataset.points, 10);

      if (!pagesScores[page]) {
        pagesScores[page] = 0
      }

      pagesScores[page] += points
    }
    if (pageTwo) {
      const pointsTwo = parseInt(input.dataset.pointsTwo, 10);

      if (!pagesScores[pageTwo]) {
        pagesScores[pageTwo] = 0;
      }

      pagesScores[pageTwo] += pointsTwo;
    }
  });

  /* Comparer tous les scores */
  let bestPage;
  let maxScore = 0;
  for (const [page, score] of Object.entries(pagesScores)) {
    if (score > maxScore) {
      maxScore = score;
      bestPage = page;
    }
  }
  // console.log('page:', bestPage);


  /* Afficher le formulaire correspondant à la best page */
  showResultPage(bestPage);
}

function showResultPage(bestPage) {
  results.forEach((result) => {
    if (result.dataset.page == bestPage) {
      result.classList.remove('hidden');
    }
  });
}

questions.forEach((question) => {
  const inputs = question.querySelectorAll('input');
  inputs.forEach((input) => {
		input.addEventListener("click", () => {
			// Avance à l'étape suivante automatiquement
			currentStep++;

			// if (currentStep < totalSteps) {
				showStep(currentStep);
			if (currentStep === totalSteps) {
				// Fin du questionnaire
				updateScores();
			}
		});
  });
});
